export const MAPS_API_KEY = process.env.REACT_APP_GOOGLE_MAP_KEY || '';
export const GEOCODING_API_KEY = process.env.REACT_APP_GEOCODING_KEY || '';
export const DEFAULT_LATITUDE = 45.034737;
export const DEFAULT_LONGITUDE = 20.095463;
export const DEFAULT_ZOOM = 10;
